/* Collectiefilter-aanpassingen:
   - prijs als schuifbalk boven Dawn's twee velden
   - filtergroepen die we (nog) niet willen tonen, verbergen (bijv. "Kleur" = kleurcodes) */
(function () {
  var HIDE_FILTERS = ['kleur']; // labels in kleine letters; leeg = niks verbergen

  function hideFilters() {
    if (!HIDE_FILTERS.length) return;
    var groups = document.querySelectorAll(
      '.facets__disclosure, .facets__disclosure-vertical, .mobile-facets__details, .js-filter'
    );
    groups.forEach(function (g) {
      var head = g.querySelector('summary, .facets__summary, .mobile-facets__summary');
      var label = (head ? head.textContent : '').replace(/\s+/g, ' ').trim().toLowerCase();
      for (var i = 0; i < HIDE_FILTERS.length; i++) {
        if (label.indexOf(HIDE_FILTERS[i]) === 0) { g.style.display = 'none'; break; }
      }
    });
  }

  // (De Martindale-uitleg wordt nu server-side in snippets/facets.liquid gerenderd.)

  // De echte Shopify-variantprijs is per 10cm; overal elders tonen we per meter (×10).
  // Het filter blijft technisch op de per-10cm-prijs werken (dat moet ook), alleen het label toont ×10.
  function euro(n) { return '€ ' + Math.round(n * 10); }

  function build(pr) {
    if (pr.dataset.stofSlider) return;
    pr.dataset.stofSlider = '1';

    var gte = pr.querySelector('input[name="filter.v.price.gte"]');
    var lte = pr.querySelector('input[name="filter.v.price.lte"]');
    if (!gte || !lte) return;

    var min = parseFloat((gte.dataset.min || '0').replace(',', '.')) || 0;
    var max = parseFloat((gte.dataset.max || lte.dataset.max || '0').replace(',', '.')) || 0;
    if (max <= min) return;

    var lo = gte.value ? parseFloat(gte.value.replace(',', '.')) : min;
    var hi = lte.value ? parseFloat(lte.value.replace(',', '.')) : max;

    // Dawn's Van/Aan-velden + 'hoogste prijs is'-tekst verbergen (blijven wel in de DOM voor het filteren)
    pr.querySelectorAll('.field, .field-currency').forEach(function (el) { el.style.display = 'none'; });
    var hdr = pr.parentElement && pr.parentElement.querySelector('.facets__header-vertical, .mobile-facets__highest-price-value, .facets__selected');
    if (hdr && /hoogste prijs|highest price/i.test(hdr.textContent)) hdr.style.display = 'none';

    var wrap = document.createElement('div');
    wrap.className = 'stof-pslider';
    wrap.innerHTML =
      '<div class="stof-pslider__track"><div class="stof-pslider__fill"></div>' +
      '<button type="button" class="stof-pslider__thumb" data-h="lo" aria-label="Minimumprijs"></button>' +
      '<button type="button" class="stof-pslider__thumb" data-h="hi" aria-label="Maximumprijs"></button></div>' +
      '<div class="stof-pslider__out"><span data-lo></span><span data-hi></span></div>';
    pr.insertBefore(wrap, pr.firstChild);

    var track = wrap.querySelector('.stof-pslider__track');
    var fill = wrap.querySelector('.stof-pslider__fill');
    var thumbLo = wrap.querySelector('[data-h="lo"]');
    var thumbHi = wrap.querySelector('[data-h="hi"]');
    var outLo = wrap.querySelector('[data-lo]');
    var outHi = wrap.querySelector('[data-hi]');

    function pct(v) { return ((v - min) / (max - min)) * 100; }

    function paint() {
      thumbLo.style.left = pct(lo) + '%';
      thumbHi.style.left = pct(hi) + '%';
      fill.style.left = pct(lo) + '%';
      fill.style.right = (100 - pct(hi)) + '%';
      outLo.textContent = euro(lo);
      outHi.textContent = euro(hi);
    }
    paint();

    function commit() {
      // Dawn's eigen <price-range>-component (facets.js PriceRange.setMinAndMaxValues)
      // zet bij een change-event het andere veld se data-min/data-max op basis van DEZE
      // waarde. Laat je één veld leeg (= "geen grens"), dan leest Dawn dat als 0 en trekt
      // het gelijk aan de zojuist gezette grens -> beide velden komen op hetzelfde bedrag.
      // Daarom: zodra er echt iets versleept is, altijd BEIDE velden expliciet vullen.
      if (lo <= min && hi >= max) {
        gte.value = '';
        lte.value = '';
      } else {
        gte.value = Math.round(lo);
        lte.value = Math.round(hi);
      }
      [gte, lte].forEach(function (el) {
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    function drag(which) {
      return function (e) {
        e.preventDefault();
        var r = track.getBoundingClientRect();
        function move(ev) {
          var x = (ev.touches ? ev.touches[0].clientX : ev.clientX) - r.left;
          var v = min + (Math.max(0, Math.min(1, x / r.width))) * (max - min);
          v = Math.round(v);
          if (which === 'lo') lo = Math.min(v, hi - 1);
          else hi = Math.max(v, lo + 1);
          lo = Math.max(min, lo); hi = Math.min(max, hi);
          paint();
        }
        function up() {
          document.removeEventListener('pointermove', move);
          document.removeEventListener('pointerup', up);
          commit();
        }
        document.addEventListener('pointermove', move);
        document.addEventListener('pointerup', up);
      };
    }
    thumbLo.addEventListener('pointerdown', drag('lo'));
    thumbHi.addEventListener('pointerdown', drag('hi'));

    // als Dawn de velden zelf wijzigt, slider mee laten lopen
    [gte, lte].forEach(function (el) {
      el.addEventListener('change', function () {
        lo = gte.value ? parseFloat(gte.value.replace(',', '.')) : min;
        hi = lte.value ? parseFloat(lte.value.replace(',', '.')) : max;
        paint();
      });
    });
  }

  function scan() {
    document.querySelectorAll('price-range.facets__price').forEach(build);
    hideFilters();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  // facets worden opnieuw gerenderd na filteren
  new MutationObserver(function () { clearTimeout(scan._t); scan._t = setTimeout(scan, 150); })
    .observe(document.body, { childList: true, subtree: true });
})();
